// react-router action
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

// Auth constants
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT = 'LOGOUT'
export const LOGOUT_COMPLETE = 'LOGOUT_COMPLETE'
export const ACCESS_ALLOWED = 'ACCESS_ALLOWED'
export const ACCESS_NOT_ALLOWED = 'ACCESS_NOT_ALLOWED'
export const CHANGE_TOKEN = 'CHANGE_TOKEN'
export const CHANGE_TOTEM_TOKEN = 'CHANGE_TOTEM_TOKEN'
export const FETCH_ROUTES_SUCCESS = 'FETCH_ROUTES_SUCCESS'
// Spinner
export const SHOW_SPINNER = 'SHOW_SPINNER'
export const HIDE_SPINNER = 'HIDE_SPINNER'

// Pagination
export const GET_PAGES = 'GET_PAGES'
export const FETCH_PAGE_SUCCESS = 'FETCH_PAGE_SUCCESS'

// Menus
export const FETCH_MENUS_REQUEST = 'FETCH_MENUS_REQUEST'
export const FETCH_MENUS_SUCCESS = 'FETCH_MENUS_SUCCESS'
export const FETCH_MENUS_ERROR = 'FETCH_MENUS_ERROR'
export const ACCESS_MENUS_REQUEST = 'ACCESS_MENUS_REQUEST'
export const ACCESS_MENUS_SUCCESS = 'ACCESS_MENUS_SUCCESS'
export const ACCESS_MENUS_ERROR = 'ACCESS_MENUS_ERROR'
export const FETCH_PERMISSIONS_REQUEST = 'FETCH_PERMISSIONS_REQUEST'
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS'
export const FETCH_PERMISSIONS_ERROR = 'FETCH_PERMISSIONS_ERROR'

// Reports
export const FETCH_REPORT_REQUEST = 'FETCH_REPORT_REQUEST'
export const FETCH_REPORT_SUCCESS = 'FETCH_REPORT_SUCCESS'
export const FETCH_REPORT_ERROR = 'FETCH_REPORT_ERROR'

// Missions
export const FETCH_MISSIONS_REQUEST = 'FETCH_MISSIONS_REQUEST'
export const FETCH_MISSIONS_SUCCESS = 'FETCH_MISSIONS_SUCCESS'
export const FETCH_MISSIONS_ERROR = 'FETCH_MISSIONS_ERROR'
export const UPDATE_MISSION_REQUEST = 'UPDATE_MISSION_REQUEST'
export const UPDATE_MISSION_SUCCESS = 'UPDATE_MISSION_SUCCESS'
export const UPDATE_MISSION_ERROR = 'UPDATE_MISSION_ERROR'
export const GET_MISSION_FROM_LIST = 'GET_MISSION_FROM_LIST'
export const RESET_MISSIONS = 'RESET_MISSIONS'
export const RESET_EDIT_MISSION = 'RESET_EDIT_MISSION'

// MenuMission
export const UPDATE_MENU_MISSION_REQUEST = 'UPDATE_MENU_MISSION_REQUEST'
export const UPDATE_MENU_MISSION_SUCCESS = 'UPDATE_MENU_MISSION_SUCCESS'
export const UPDATE_MENU_MISSION_ERROR = 'UPDATE_MENU_MISSION_ERROR'
export const GET_MENU_MISSION_FROM_LIST = 'GET_MENU_MISSION_FROM_LIST'
export const RESET_MENU_MISSIONS = 'RESET_MENU_MISSIONS'
export const RESET_EDIT_MENU_MISSION = 'RESET_EDIT_MENU_MISSION'
export const REMOVE_MENU_MISSION_SUCCESS = 'REMOVE_MENU_MISSION_SUCCESS'
export const REMOVE_MENU_MISSION_ERROR = 'REMOVE_MENU_MISSION_ERROR'
export const FETCH_MENU_MISSIONS_REQUEST_V2 = 'FETCH_MENU_MISSIONS_REQUEST_V2'
export const FETCH_MENU_MISSIONS_ERROR_V2 = 'FETCH_MENU_MISSIONS_ERROR_V2'
export const FETCH_MENU_MISSIONS_SUCCESS_V2 = 'FETCH_MENU_MISSIONS_SUCCESS_V2'
export const SAVE_MENU_MISSIONS_REQUEST_V2 = 'SAVE_MENU_MISSIONS_REQUEST_V2'
export const SAVE_MENU_MISSIONS_SUCCESS_V2 = 'SAVE_MENU_MISSIONS_SUCCESS_V2'
export const SAVE_MENU_MISSIONS_ERROR_V2 = 'SAVE_MENU_MISSIONS_ERROR_V2'
export const ALL_PROFILES = 'ALL_PROFILES'
export const UPDATE_MENU_MISSIONS_REQUEST_V2 = 'UPDATE_MENU_MISSIONS_REQUEST_V2'
export const UPDATE_MENU_MISSIONS_SUCCESS_V2 = 'UPDATE_MENU_MISSIONS_SUCCESS_V2'
export const UPDATE_MENU_MISSIONS_ERROR_V2 = 'UPDATE_MENU_MISSIONS_ERROR_V2'
export const MENU_MISSION_REMOVE_REQUEST_V2 = 'MENU_MISSION_REMOVE_REQUEST_V2'
export const MENU_MISSION_REMOVE_SUCCESS_V2 = 'MENU_MISSION_REMOVE_SUCCESS_V2'
export const MENU_MISSION_REMOVE_ERROR_V2 = 'MENU_MISSION_REMOVE_ERROR_V2'
export const MENU_MISSION_UPDATE_PERMISSIONS_REQUEST =
  'MENU_MISSION_UPDATE_PERMISSIONS_REQUEST'
export const MENU_MISSION_UPDATE_PERMISSIONS_SUCCESS =
  'MENU_MISSION_UPDATE_PERMISSIONS_SUCCESS'
export const MENU_MISSION_UPDATE_PERMISSIONS_ERROR =
  'MENU_MISSION_UPDATE_PERMISSIONS_ERROR'

// Ruptures
export const FETCH_RUPTURE_REQUEST = 'FETCH_RUPTURE_REQUEST'
export const FETCH_RUPTURE_SUCCESS = 'FETCH_RUPTURE_SUCCESS'
export const FETCH_RUPTURE_ERROR = 'FETCH_RUPTURE_ERROR'

// CommercialManagements
export const FETCH_COMMERCIAL_MANAGEMENT_REQUEST =
  'FETCH_COMMERCIAL_MANAGEMENT_REQUEST'
export const FETCH_COMMERCIAL_MANAGEMENT_SUCCESS =
  'FETCH_COMMERCIAL_MANAGEMENT_SUCCESS'
export const FETCH_COMMERCIAL_MANAGEMENT_ERROR =
  'FETCH_COMMERCIAL_MANAGEMENT_ERROR'


  export const FETCH_COMMERCIAL_MANAGEMENT_REPORT_REQUEST =
  'FETCH_COMMERCIAL_MANAGEMENT_REPORT_REQUEST'
export const FETCH_COMMERCIAL_MANAGEMENT_REPORT_SUCCESS =
  'FETCH_COMMERCIAL_MANAGEMENT_REPORT_SUCCESS'
export const FETCH_COMMERCIAL_MANAGEMENT_REPORT_ERROR =
  'FETCH_COMMERCIAL_MANAGEMENT_REPORT_ERROR'

// Code 8 Occurrences
export const FETCH_CODE8OCCURRENCES_REQUEST = 'FETCH_CODE8OCCURRENCES_REQUEST'
export const FETCH_CODE8OCCURRENCES_SUCCESS = 'FETCH_CODE8OCCURRENCES_SUCCESS'
export const FETCH_CODE8OCCURRENCES_ERROR = 'FETCH_CODE8OCCURRENCES_ERROR'

export const FETCH_CODE8OCCURRENCES_REQUEST_V2 = 'FETCH_CODE8OCCURRENCES_REQUEST_V2'
export const FETCH_CODE8OCCURRENCES_SUCCESS_V2 = 'FETCH_CODE8OCCURRENCES_SUCCESS_V2'
export const FETCH_CODE8OCCURRENCES_ERROR_V2 = 'FETCH_CODE8OCCURRENCES_ERROR_V2'

export const SESSION_EXPIRED = 'SESSION_EXPIRED'

// MobileUpdate
export const FETCH_MOBILE_UPDATES_REQUEST = 'FETCH_MOBILE_UPDATES_REQUEST'
export const FETCH_MOBILE_UPDATES_SUCCESS = 'FETCH_MOBILE_UPDATES_SUCCESS'
export const FETCH_MOBILE_UPDATES_ERROR = 'FETCH_MOBILE_UPDATES_ERROR'
export const UPDATE_MOBILE_UPDATE_REQUEST = 'UPDATE_MOBILE_UPDATE_REQUEST'
export const UPDATE_MOBILE_UPDATE_SUCCESS = 'UPDATE_MOBILE_UPDATE_SUCCESS'
export const UPDATE_MOBILE_UPDATE_ERROR = 'UPDATE_MOBILE_UPDATE_ERROR'
export const REMOVE_MOBILE_UPDATE_SUCCESS = 'REMOVE_MOBILE_UPDATE_SUCCESS'
export const REMOVE_MOBILE_UPDATE_ERROR = 'REMOVE_MOBILE_UPDATE_ERROR'

// LmExpress
export const FETCH_LMEXPRESS_REQUEST = 'FETCH_LMEXPRESS_REQUEST'
export const FETCH_LMEXPRESS_SUCCESS = 'FETCH_LMEXPRESS_SUCCESS'
export const FETCH_LMEXPRESS_ERROR = 'FETCH_LMEXPRESS_ERROR'
export const FETCH_LMEXPRESS_PARAMETERS_REQUEST =
  'FETCH_LMEXPRESS_PARAMETERS_REQUEST'
export const FETCH_LMEXPRESS_PARAMETERS_SUCCESS =
  'FETCH_LMEXPRESS_PARAMETERS_SUCCESS'
export const FETCH_LMEXPRESS_PARAMETERS_ERROR =
  'FETCH_LMEXPRESS_PARAMETERS_ERROR'
export const UPDATE_LMEXPRESS_PARAMETERS_REQUEST =
  'UPDATE_LMEXPRESS_PARAMETERS_REQUEST'
export const UPDATE_LMEXPRESS_PARAMETERS_SUCCESS =
  'UPDATE_LMEXPRESS_PARAMETERS_SUCCESS'
export const UPDATE_LMEXPRESS_PARAMETERS_ERROR =
  'UPDATE_LMEXPRESS_PARAMETERS_ERROR'

// Suggestions
export const FETCH_SUGGESTIONS_REQUEST = 'FETCH_SUGGESTIONS_REQUEST'
export const FETCH_SUGGESTIONS_SUCCESS = 'FETCH_SUGGESTIONS_SUCCESS'
export const FETCH_SUGGESTIONS_ERROR = 'FETCH_SUGGESTIONS_ERROR'
export const UPDATE_SUGGESTION_REQUEST = 'UPDATE_SUGGESTION_REQUEST'
export const UPDATE_SUGGESTION_SUCCESS = 'UPDATE_SUGGESTION_SUCCESS'
export const UPDATE_SUGGESTION_ERROR = 'UPDATE_SUGGESTION_ERROR'
export const GET_SUGGESTION_FROM_LIST = 'GET_SUGGESTION_FROM_LIST'
export const RESET_SUGGESTIONS = 'RESET_SUGGESTIONS'
export const RESET_EDIT_SUGGESTION = 'RESET_EDIT_SUGGESTION'
export const SAVE_SUGGESTIONS_FILTERS = 'SAVE_SUGGESTIONS_FILTERS'
export const RESET_SUGGESTIONS_FILTERS = 'RESET_SUGGESTIONS_FILTERS'
export const DELETE_SUGGESTION_REQUEST = 'DELETE_SUGGESTION_REQUEST'
export const DELETE_SUGGESTION_SUCCESS = 'DELETE_SUGGESTION_SUCCESS'
export const DELETE_SUGGESTION_ERROR = 'DELETE_SUGGESTION_ERROR'

// Home/Vídeo
export const FETCH_HOME_VIDEO_REQUEST = 'FETCH_HOME_VIDEO_REQUEST'
export const FETCH_HOME_VIDEO_SUCCESS = 'FETCH_HOME_VIDEO_SUCCESS'
export const FETCH_HOME_VIDEO_ERROR = 'FETCH_HOME_VIDEO_ERROR'
export const FETCH_VIDEOS_REQUEST = 'FETCH_VIDEOS_REQUEST'
export const FETCH_VIDEOS_SUCCESS = 'FETCH_VIDEOS_SUCCESS'
export const FETCH_VIDEOS_ERROR = 'FETCH_VIDEOS_ERROR'
export const UPDATE_VIDEOS_REQUEST = 'UPDATE_VIDEOS_REQUEST'
export const UPDATE_VIDEOS_SUCCESS = 'UPDATE_VIDEOS_SUCCESS'
export const UPDATE_VIDEOS_ERROR = 'UPDATE_VIDEOS_ERROR'
export const REMOVE_VIDEOS_SUCCESS = 'REMOVE_VIDEOS_SUCCESS'
export const REMOVE_VIDEOS_ERROR = 'REMOVE_VIDEOS_ERROR'
export const FETCH_LATEST_VIDEO_REQUEST = 'FETCH_LATEST_VIDEO_REQUEST'
export const FETCH_LATEST_VIDEO_SUCCESS = 'FETCH_LATEST_VIDEO_SUCCESS'
export const FETCH_LATEST_VIDEO_ERROR = 'FETCH_LATEST_VIDEO_ERROR'
export const FETCH_USER_VERSION_VALIDATION_REQUEST =
  'FETCH_USER_VERSION_VALIDATION_REQUEST'
export const FETCH_USER_VERSION_VALIDATION_SUCCESS =
  'FETCH_USER_VERSION_VALIDATION_SUCCESS'
export const FETCH_USER_VERSION_VALIDATION_ERROR =
  'FETCH_USER_VERSION_VALIDATION_ERROR'
export const FETCH_SPRINT_NOTES_REQUEST = 'FETCH_SPRINT_NOTES_REQUEST'
export const FETCH_SPRINT_NOTES_SUCCESS = 'FETCH_SPRINT_NOTES_SUCCESS'
export const FETCH_SPRINT_NOTES_ERROR = 'FETCH_SPRINT_NOTES_ERROR'
export const RESET_SPRINT_NOTES = 'RESET_SPRINT_NOTES'

// Analytics
export const FETCH_MOST_ACCESSED_MENUS_REQUEST =
  'FETCH_MOST_ACCESSED_MENUS_REQUEST'

export const FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE_V2 = "FETCH_MOST_ACESSED_MENUS_SUCCESS_MOBILE_V2"
export const FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB_V2 = "FETCH_MOST_ACESSED_MENUS_SUCCESS_WEB_V2"
export const FECTH_MOST_ACESSED_MENUS_SUCCESS = "FETCH_MOST_ACESSED_MENUS_SUCCESS"
export const FECTH_MOST_ACESSED_MENUS_ERROR = "FETCH_MOST_ACESSED_MENUS_ERROR"
export const FETCH_MOST_ACCESSED_MENUS_REQUEST_NEW =
  'FETCH_MOST_ACCESSED_MENUS_REQUEST_NEW'

export const FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB =
  'FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB'
export const FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE =
  'FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE'
export const FETCH_MOST_ACCESSED_MENUS_ERROR = 'FETCH_MOST_ACCESSED_MENUS_ERROR'
export const FETCH_DEVICES_UPDATE_REQUEST = 'FETCH_DEVICES_UPDATE_REQUEST'
export const FETCH_DEVICES_UPDATE_SUCCESS = 'FETCH_DEVICES_UPDATE_SUCCESS'
export const FETCH_DEVICES_UPDATE_ERROR = 'FETCH_DEVICES_UPDATE_ERROR'

export const FETCH_FUNCIONALITIES_DETAILS_SUCCESS = 'FETCH_FUNCIONALITIES_DETAILS_SUCCESS'
export const FETCH_FUNCIONALITIES_DETAILS_REQUEST = 'FETCH_FUNCIONALITIES_DETAILS_REQUEST'
export const FETCH_FUNCIONALITIES_DETAILS_ERROR = 'FETCH_FUNCIONALITIES_DETAILS_ERROR'
export const FETCH_RELATORY_DETAILS_SUCCESS = 'FETCH_RELATORY_DETAILS_SUCCESS'
export const FETCH_RELATORY_DETAILS_REQUEST = 'FETCH_RELATORY_DETAILS_REQUEST'
export const FETCH_RELATORY_DETAILS_ERROR = 'FETCH_RELATORY_DETAILS_ERROR'
export const FETCH_FILTERS_GLOBAL_SUCCESS = "FETCH_FILTERS_GLOBAL_SUCCESS"

export const FETCH_ACTIVE_INACTIVE_USERS_REQUEST =
  'FETCH_ACTIVE_INACTIVE_USERS_REQUEST'
export const FETCH_ACTIVE_INACTIVE_USERS_SUCCESS =
  'FETCH_ACTIVE_INACTIVE_USERS_SUCCESS'
export const FETCH_ACTIVE_INACTIVE_USERS_ERROR =
  'FETCH_ACTIVE_INACTIVE_USERS_ERROR'
export const FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST =
  'FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST'
export const FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_SUCCESS =
  'FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_SUCCESS'
export const FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR =
  'FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR'
export const FETCH_LIST_MOST_ACCESSED_MENUS_WEB_REQUEST =
  'FETCH_LIST_MOST_ACCESSED_MENUS_WEB_REQUEST'
export const FETCH_LIST_MOST_ACCESSED_MENUS_WEB_SUCCESS =
  'FETCH_LIST_MOST_ACCESSED_MENUS_WEB_SUCCESS'
export const FETCH_LIST_MOST_ACCESSED_MENUS_WEB_ERROR =
  'FETCH_LIST_MOST_ACCESSED_MENUS_WEB_ERROR'

// Satisfaction survey
export const FETCH_SATISFACTION_SURVEY_SUCCESS =
  'FETCH_SATISFACTION_SURVEY_SUCCESS'
export const FETCH_SATISFACTION_SURVEY_ERROR =
  'FETCH_SATISFACTION_SURVEY_ERROR'
export const CREATE_SATISFACTION_SURVEY_SUCCESS =
  'CREATE_SATISFACTION_SURVEY_SUCCESS'
export const CREATE_SATISFACTION_SURVEY_ERROR =
  'CREATE_SATISFACTION_SURVEY_ERROR'



// IRC
export const FETCH_IRC_LIST_REQUEST = 'FETCH_IRC_LIST_REQUEST'
export const FETCH_IRC_LIST_SUCCESS = 'FETCH_IRC_LIST_SUCCESS'
export const FETCH_IRC_LIST_ERROR = 'FETCH_IRC_LIST_ERROR'
export const SAVE_IRC_LIST_REQUEST = 'SAVE_IRC_LIST_REQUEST'
export const SAVE_IRC_LIST_SUCCESS = 'SAVE_IRC_LIST_SUCCESS'
export const DELETE_IRC_LIST_REQUEST = 'DELETE_IRC_LIST_REQUEST'
export const DELETE_IRC_LIST_SUCCESS = 'DELETE_IRC_LIST_SUCCESS'
export const DELETE_IRC_LIST_ERROR = 'DELETE_IRC_LIST_ERROR'
export const SAVE_IRC_LIST_ERROR = 'SAVE_IRC_LIST_ERROR'
export const SAVE_IRC_LIST_RESET_ERROR = 'SAVE_IRC_LIST_RESET_ERROR'
export const INVENTORY_CRITERIA_VALIDATE_PRODUCTS_BEFORE =
  'INVENTORY_CRITERIA_VALIDATE_PRODUCTS_BEFORE'
export const INVENTORY_CRITERIA_VALIDATE_PRODUCTS_SUCCESS =
  'INVENTORY_CRITERIA_VALIDATE_PRODUCTS_SUCCESS'
export const INVENTORY_CRITERIA_VALIDATE_PRODUCTS_ERROR =
  'INVENTORY_CRITERIA_VALIDATE_PRODUCTS_ERROR'


// SUPPLY
export const FETCH_POSITIONS_LIST = "FETCH_POSITIONS_LIST"
export const FETCH_POSITIONS_LIST_ERROR = "FETCH_POSITIONS_LIST_ERROR"
export const FETCH_POSITIONS_LIST_SUCCESS = "FETCH_POSITIONS_LIST_SUCCESS"
export const FETCH_POSITIONS_SUCCESS = "FETCH_POSITION_SUCCESS"
export const FETCH_POSITIONS_ERROR = "FETCH_POSITION_ERROR"
export const SAVE_IRC_SUPPLY_LIST = "SAVE_IRC_SUPPLY_LIST"
export const SAVE_IRC_SUPPLY_LIST_ERROR = "SAVE_IRC_SUPPLY_LIST"
export const SAVE_IRC_SUPPLY_LIST_SUCCESS = "SAVE_IRC_SUPPLY_LIST"

export const EXCLUDE_IRC_SUPPLY_LIST = "EXCLUDE_IRC_SUPPLY_LIST"
export const EXCLUDE_IRC_SUPPLY_LIST_ERROR = "EXCLUDE_IRC_SUPPLY_LIST_ERROR"
export const EXCLUDE_IRC_SUPPLY_LIST_SUCESS = "EXCLUDE_IRC_SUPPLY_LIST_SUCESS"

export const FETCH_SUPPLY_POSITIONS_NOT_COUNTED_SUCCESS = "FETCH_SUPPLY_POSITIONS_NOT_COUNTED_SUCCESS"
export const FETCH_SUPPLY_POSITIONS_NOT_COUNTED_ERROR = "FETCH_SUPPLY_POSITIONS_NOT_COUNTED_ERROR"
export const FETCH_SUPPLY_POSITIONS_NOT_COUNTED = "FETCH_SUPPLY_POSITIONS_NOT_COUNTED"

export const FETCH_SUPPLY_HISTORY_COUNT_SUCCESS = "FETCH_SUPPLY_HISTORY_COUNT_SUCCESS"
export const FETCH_SUPPLY_HISTORY_COUNT_ERROR = "FETCH_SUPPLY_HISTORY_COUNT_ERROR"
export const FETCH_SUPPLY_HISTORY_COUNT = "FETCH_SUPPLY_HISTORY_COUNT"

// IRC AUTONOMOUS
export const FETCH_IRC_AUTONOMOUS_PARAMETERS_REQUEST = 'FETCH_IRC_AUTONOMOUS_PARAMETERS_REQUEST'
export const FETCH_IRC_AUTONOMOUS_PARAMETERS_SUCCESS = 'FETCH_IRC_AUTONOMOUS_PARAMETERS_SUCCESS'
export const FETCH_IRC_AUTONOMOUS_PARAMETERS_ERROR = 'FETCH_IRC_AUTONOMOUS_PARAMETERS_ERROR'
export const SAVE_IRC_AUTONOMOUS_PARAMETERS_REQUEST = 'SAVE_IRC_AUTONOMOUS_PARAMETERS_REQUEST'
export const SAVE_IRC_AUTONOMOUS_PARAMETERS_SUCCESS = 'SAVE_IRC_AUTONOMOUS_PARAMETERS_SUCCESS'
export const SAVE_IRC_AUTONOMOUS_PARAMETERS_ERROR = 'SAVE_IRC_AUTONOMOUS_PARAMETERS_ERROR'

// Schedule block
export const FETCH_SCHEDULE_BLOCK_REQUEST = 'FETCH_SCHEDULE_BLOCK_REQUEST'
export const FETCH_SCHEDULE_BLOCK_SUCCESS = 'FETCH_SCHEDULE_BLOCK_SUCCESS'
export const FETCH_SCHEDULE_BLOCK_ERROR = 'FETCH_SCHEDULE_BLOCK_ERROR'
export const SAVE_SCHEDULE_BLOCK_REQUEST = 'SAVE_SCHEDULE_BLOCK_REQUEST'
export const SAVE_SCHEDULE_BLOCK_SUCCESS = 'SAVE_SCHEDULE_BLOCK_SUCCESS'
export const SAVE_SCHEDULE_BLOCK_ERROR = 'SAVE_SCHEDULE_BLOCK_ERROR'
export const DELETE_SCHEDULE_BLOCK_REQUEST = 'DELETE_SCHEDULE_BLOCK_REQUEST'
export const DELETE_SCHEDULE_BLOCK_SUCCESS = 'DELETE_SCHEDULE_BLOCK_SUCCESS'
export const DELETE_SCHEDULE_BLOCK_ERROR = 'DELETE_SCHEDULE_BLOCK_ERROR'

// Gama
export const FETCH_GAMA_SECTIONS_REQUEST = 'FETCH_GAMA_SECTIONS_REQUEST'
export const FETCH_GAMA_SECTIONS_SUCCESS = 'FETCH_GAMA_SECTIONS_SUCCESS'
export const FETCH_GAMA_SECTIONS_ERROR = 'FETCH_GAMA_SECTIONS_ERROR'
export const FETCH_ALL_GAMA_BY_YEAR_REQUEST = 'FETCH_ALL_GAMA_BY_YEAR_REQUEST'
export const FETCH_ALL_GAMA_BY_YEAR_SUCCESS = 'FETCH_ALL_GAMA_BY_YEAR_SUCCESS'
export const FETCH_ALL_GAMA_BY_YEAR_ERROR = 'FETCH_ALL_GAMA_BY_YEAR_ERROR'
export const SAVE_GAMA_FORM_REQUEST = 'SAVE_GAMA_FORM_REQUEST'
export const SAVE_GAMA_FORM_SUCCESS = 'SAVE_GAMA_FORM_SUCCESS'
export const SAVE_GAMA_FORM_ERROR = 'SAVE_GAMA_FORM_ERROR'
export const RESET_STATE_GAMA = "RESET_STATE_GAMA"


export const FETCH_BRANCHS_REQUEST = 'FETCH_BRANCHS_REQUEST'
export const FETCH_BRANCHS_SUCCESS = 'FETCH_BRANCHS_SUCCESS'
export const FETCH_BRANCHS_ERROR = 'FETCH_BRANCHS_ERROR'

// Justifications
export const FETCH_JUSTIFICATIONS_LIST_REQUEST =
  'FETCH_JUSTIFICATIONS_LIST_REQUEST'
export const FETCH_JUSTIFICATIONS_LIST_SUCCESS =
  'FETCH_JUSTIFICATIONS_LIST_SUCCESS'
export const FETCH_JUSTIFICATIONS_LIST_ERROR = 'FETCH_JUSTIFICATIONS_LIST_ERROR'
export const UPDATE_JUSTIFICATION_REQUEST = 'UPDATE_JUSTIFICATION_REQUEST'
export const UPDATE_JUSTIFICATION_SUCCESS = 'UPDATE_JUSTIFICATION_SUCCESS'
export const UPDATE_JUSTIFICATION_ERROR = 'UPDATE_JUSTIFICATION_ERROR'


// IRC Justifications
export const FETCH_IRC_JUSTIFICATIONS_REQUEST = 'FETCH_IRC_JUSTIFICATIONS_REQUEST'
export const FETCH_IRC_JUSTIFICATIONS_SUCCESS = 'FETCH_IRC_JUSTIFICATIONS_SUCCESS'
export const FETCH_IRC_JUSTIFICATIONS_ERROR = 'FETCH_IRC_JUSTIFICATIONS_ERROR'

export const SAVE_IRC_JUSTIFICATION_REQUEST = 'SAVE_IRC_JUSTIFICATION_REQUEST'
export const SAVE_IRC_JUSTIFICATION_SUCCESS = 'SAVE_IRC_JUSTIFICATION_SUCCESS'
export const SAVE_IRC_JUSTIFICATION_ERROR = 'SAVE_IRC_JUSTIFICATION_ERROR'

export const SAVE_ALL_IRC_JUSTIFICATION_REQUEST = 'SAVE_ALL_IRC_JUSTIFICATION_REQUEST'
export const SAVE_ALL_IRC_JUSTIFICATION_SUCCESS = 'SAVE_ALL_IRC_JUSTIFICATION_SUCCESS'
export const SAVE_ALL_IRC_JUSTIFICATION_ERROR = 'SAVE_ALL_IRC_JUSTIFICATION_ERROR'

export const UPDATE_IRC_JUSTIFICATION_REQUEST = 'UPDATE_IRC_JUSTIFICATION_REQUEST'
export const UPDATE_IRC_JUSTIFICATION_SUCCESS = 'UPDATE_IRC_JUSTIFICATION_SUCCESS'
export const UPDATE_IRC_JUSTIFICATION_ERROR = 'UPDATE_IRC_JUSTIFICATION_ERROR'

export const DELETE_IRC_JUSTIFICATION_REQUEST = 'DELETE_IRC_JUSTIFICATION_REQUEST'
export const DELETE_IRC_JUSTIFICATION_SUCCESS = 'DELETE_IRC_JUSTIFICATION_SUCCESS'
export const DELETE_IRC_JUSTIFICATION_ERROR = 'DELETE_IRC_JUSTIFICATION_ERROR'



// Weekly block
export const FETCH_WEEKLY_BLOCK_REQUEST = 'FETCH_WEEKLY_BLOCK_REQUEST'
export const FETCH_WEEKLY_BLOCK_SUCCESS = 'FETCH_WEEKLY_BLOCK_SUCCESS'
export const FETCH_WEEKLY_BLOCK_ERROR = 'FETCH_WEEKLY_BLOCK_ERROR'
export const SAVE_WEEKLY_BLOCK_REQUEST = 'SAVE_WEEKLY_BLOCK_REQUEST'
export const SAVE_WEEKLY_BLOCK_SUCCESS = 'SAVE_WEEKLY_BLOCK_SUCCESS'
export const SAVE_WEEKLY_BLOCK_ERROR = 'SAVE_WEEKLY_BLOCK_ERROR'

// Sales coaching
export const FETCH_SALES_COACHING_COUNT_REQUEST =
  'FETCH_SALES_COACHING_COUNT_REQUEST'
export const FETCH_SALES_COACHING_COUNT_SUCCESS =
  'FETCH_SALES_COACHING_COUNT_SUCCESS'
export const FETCH_SALES_COACHING_COUNT_ERROR =
  'FETCH_SALES_COACHING_COUNT_ERROR'

// Rotative Inventory
export const FETCH_ROTATIVE_INVENTORY_REQUEST =
  'FETCH_ROTATIVE_INVENTORY_REQUEST'
export const FETCH_ROTATIVE_INVENTORY_SUCCESS =
  'FETCH_ROTATIVE_INVENTORY_SUCCESS'
export const FETCH_ROTATIVE_INVENTORY_ERROR = 'FETCH_ROTATIVE_INVENTORY_ERROR'
export const INACTIVATE_ROTATIVE_INVENTORY_SUCCESS =
  'INACTIVATE_ROTATIVE_INVENTORY_SUCCESS'
export const INACTIVATE_ROTATIVE_INVENTORY_ERROR =
  'INACTIVATE_ROTATIVE_INVENTORY_ERROR'

// Zero Cost Dpac items
export const FETCH_ZERO_COST_DPAC_ITEMS_REQUEST =
  'FETCH_ZERO_COST_DPAC_ITEMS_REQUEST'
export const FETCH_ZERO_COST_DPAC_ITEMS_SUCCESS =
  'FETCH_ZERO_COST_DPAC_ITEMS_SUCCESS'
export const FETCH_ZERO_COST_DPAC_ITEMS_ERROR = 'FETCH_ZERO_COST_DPAC_ITEMS_ERROR'

// ITEMS RESET IN THE COUNT OF THE DAY 
export const FETCH_ROTATIVE_INVENTORY_FLUX_REQUEST =
  'FETCH_ROTATIVE_INVENTORY_FLUX_REQUEST'
export const FETCH_ROTATIVE_INVENTORY_FLUX_SUCCESS =
  'FETCH_ROTATIVE_INVENTORY_FLUX_SUCCESS'
export const FETCH_ROTATIVE_INVENTORY_FLUX_ERROR = 'FETCH_ROTATIVE_INVENTORY_FLUX_ERROR'

// Total Accuracy
export const FETCH_TOTAL_ACCURACY_REQUEST = 'FETCH_TOTAL_ACCURACY_REQUEST'
export const FETCH_TOTAL_ACCURACY_SUCCESS = 'FETCH_TOTAL_ACCURACY_SUCCESS'
export const FETCH_TOTAL_ACCURACY_ERROR = 'FETCH_TOTAL_ACCURACY_ERROR'
export const CLEAR_TOTAL_ACCURACY = 'CLEAR_TOTAL_ACCURACY'
export const CANCEL_TOTAL_ACCURACY = 'CANCEL_TOTAL_ACCURACY'

// Sections Accuracy
export const FETCH_SECTIONS_ACCURACY_REQUEST = 'FETCH_SECTIONS_ACCURACY_REQUEST'
export const FETCH_SECTIONS_ACCURACY_SUCCESS = 'FETCH_SECTIONS_ACCURACY_SUCCESS'
export const FETCH_EFFECTIVENESS_SUCCESS = 'FETCH_EFFECTIVENESS_SUCCESS'
export const FETCH_SECTIONS_ACCURACY_ERROR = 'FETCH_SECTIONS_ACCURACY_ERROR'

// Sections Acc Effec
export const FETCH_SECTIONS_ACC_EFFEC_REQUEST = 'FETCH_SECTIONS_ACC_EFFEC_REQUEST'
export const FETCH_SECTIONS_ACC_EFFEC_SUCCESS = 'FETCH_SECTIONS_ACC_EFFEC_SUCCESS'
export const FETCH_SECTIONS_ACC_EFFEC_ERROR = 'FETCH_SECTIONS_ACC_EFFEC_ERROR'

// Higher Adjustments
export const FETCH_HIGHER_ADJUSTMENTS_REQUEST =
  'FETCH_HIGHER_ADJUSTMENTS_REQUEST'
export const FETCH_HIGHER_ADJUSTMENTS_SUCCESS =
  'FETCH_HIGHER_ADJUSTMENTS_SUCCESS'
export const FETCH_HIGHER_ADJUSTMENTS_ERROR = 'FETCH_HIGHER_ADJUSTMENTS_ERROR'

// Punctual Adjust Parameters
export const FETCH_PARAMETERS_REQUEST = 'FETCH_PARAMETERS_REQUEST'
export const FETCH_PARAMETERS_SUCCESS = 'FETCH_PARAMETERS_SUCCESS'
export const FETCH_PARAMETERS_ERROR = 'FETCH_PARAMETERS_ERROR'
export const SAVE_PARAMETERS_REQUEST = 'SAVE_PARAMETERS_REQUEST'
export const SAVE_PARAMETERS_SUCCESS = 'SAVE_PARAMETERS_SUCCESS'
export const SAVE_PARAMETERS_ERROR = 'SAVE_PARAMETERS_ERROR'
export const RESET_ADJUST_BY_STORE = "RESET_ADJUST_BY_STORE"

// Section Block
export const LIST_SECTION_BLOCK_SUCCESS = 'LIST_SECTION_BLOCK_SUCCESS'
export const LIST_SECTION_BLOCK_ERROR = 'LIST_SECTION_BLOCK_ERROR'
export const SAVE_SECTION_BLOCK_SUCCESS = 'SAVE_SECTION_BLOCK_SUCCESS'
export const SAVE_SECTION_BLOCK_ERROR = 'SAVE_SECTION_BLOCK_ERROR'
export const DELETE_SECTION_BLOCK_SUCCESS = 'DELETE_SECTION_BLOCK_SUCCESS'
export const DELETE_SECTION_BLOCK_ERROR = 'DELETE_SECTION_BLOCK_ERROR'
export const CLEAR_SUCCESS_MESSAGE = 'CLEAR_SUCCESS_MESSAGE'

// Stores
export const LIST_STORES_SUCCESS = 'LIST_STORES_SUCCESS'
export const LIST_STORES_ERROR = 'LIST_STORES_ERROR'

// Datasheet Management
export const LIST_DATASHEET_MANAGEMENT_REQUEST = 'LIST_DATASHEET_MANAGEMENT_REQUEST'
export const LIST_DATASHEET_MANAGEMENT_SUCCESS = 'LIST_DATASHEET_MANAGEMENT_SUCCESS'
export const LIST_ALL_DATASHEET_MANAGEMENT_SUCCESS ='LIST_ALL_DATASHEET_MANAGEMENT_SUCCESS'
export const LIST_DATASHEET_MANAGEMENT_ERROR = 'LIST_DATASHEET_MANAGEMENT_ERROR'

export const SAVE_DATASHEET_MANAGEMENT_SUCCESS = 'SAVE_DATASHEET_MANAGEMENT_SUCCESS'
export const SAVE_DATASHEET_MANAGEMENT_ERROR = 'SAVE_DATASHEET_MANAGEMENT_ERROR'

export const DELETE_DATASHEET_MANAGEMENT_SUCCESS = 'DELETE_DATASHEET_MANAGEMENT_SUCCESS'
export const DELETE_DATASHEET_MANAGEMENT_ERROR = 'DELETE_DATASHEET_MANAGEMENT_ERROR'

export const CLEAR_DATASHEET_MANAGEMENT_SUCCESS_MESSAGE = 'CLEAR_DATASHEET_MANAGEMENT_SUCCESS_MESSAGE'
export const CLEAR_DATASHEET_MANAGEMENT_ERROR_TYPE ='CLEAR_DATASHEET_MANAGEMENT_ERROR_TYPE'

// Datasheet Format
export const LIST_DATASHEET_FORMAT_SUCCESS = 'LIST_DATASHEET_FORMAT_SUCCESS'
export const LIST_DATASHEET_FORMAT_ERROR = 'LIST_DATASHEET_FORMAT_ERROR'
export const LIST_DATASHEET_FORMAT_REQUEST = 'LIST_DATASHEET_FORMAT_REQUEST'

// Logo Brands
export const FETCH_LOGO_BRANDS_SUCCESS = 'FETCH_LOGO_BRANDS_SUCCESS'
export const FETCH_LOGO_BRANDS_ERROR = 'FETCH_LOGO_BRANDS_ERROR'
export const SAVE_LOGO_BRANDS_SUCCESS = 'SAVE_LOGO_BRANDS_SUCCESS'
export const SAVE_LOGO_BRANDS_ERROR = 'SAVE_LOGO_BRANDS_ERROR'
export const DELETE_LOGO_BRANDS_SUCCESS = 'DELETE_LOGO_BRANDS_SUCCESS'
export const DELETE_LOGO_BRANDS_ERROR = 'DELETE_LOGO_BRANDS_ERROR'
export const GET_LOGO_BRANDS_SUCCESS = 'GET_LOGO_BRANDS_SUCCESS'

export const FETCH_KARDEX_REQUEST = 'FETCH_KARDEX_REQUEST'
export const FETCH_KARDEX_SUCCESS = 'FETCH_KARDEX_SUCCESS'
export const FETCH_KARDEX_ERROR = 'FETCH_KARDEX_ERROR'

// Parameters
export const FETCH_PARAMETER_REQUEST = 'FETCH_PARAMETER_REQUEST'
export const FETCH_PARAMETER_SUCCESS = 'FETCH_PARAMETER_SUCCESS'
export const FETCH_PARAMETER_ERROR = 'FETCH_PARAMETER_ERROR'
export const UPDATE_PARAMETER_REQUEST = 'UPDATE_PARAMETER_REQUEST'
export const UPDATE_PARAMETER_SUCCESS = 'UPDATE_PARAMETER_SUCCESS'
export const UPDATE_PARAMETER_ERROR = 'UPDATE_PARAMETER_ERROR'
export const GET_PARAMETER_FROM_LIST = 'GET_PARAMETER_FROM_LIST'
export const RESET_PARAMETERS = 'RESET_PARAMETERS'
export const RESET_EDIT_PARAMETER = 'RESET_EDIT_PARAMETER'
export const UPDATE_PARAMETER_FILTER = 'UPDATE_PARAMETER_FILTER'

// Totem Reports
export const FETCH_TOTEM_REPORTS_REQUEST = 'FETCH_TOTEM_REPORTS_REQUEST'
export const FETCH_TOTEM_REPORTS_CANCEL = 'FETCH_TOTEM_REPORTS_CANCEL'
export const FETCH_TOTEM_REPORTS_SUCCESS = 'FETCH_TOTEM_REPORTS_SUCCESS'
export const FETCH_TOTEM_REPORTS_ERROR = 'FETCH_TOTEM_REPORTS_ERROR'

export const FETCH_TOTEM_REPORTS_CSV_REQUEST = "FETCH_TOTEM_REPORTS_CSV_REQUEST";
export const FETCH_TOTEM_REPORTS_CSV_SUCCESS = "FETCH_TOTEM_REPORTS_CSV_SUCCESS";
export const FETCH_TOTEM_REPORTS_CSV_ERROR = "FETCH_TOTEM_REPORTS_CSV_ERROR";
export const FETCH_TOTEM_REPORTS_CSV_CANCEL = "FETCH_TOTEM_REPORTS_CSV_CANCEL";

// Totem Logs
export const FETCH_TOTEM_LOGS_REQUEST = 'FETCH_TOTEM_LOGS_REQUEST'
export const FETCH_TOTEM_LOGS_SUCCESS = 'FETCH_TOTEM_LOGS_SUCCESS'
export const FETCH_TOTEM_LOGS_ERROR = 'FETCH_TOTEM_LOGS_ERROR'

export const FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_REQUEST =
  'FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_REQUEST'
export const FETCH_DJUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_SUCCESS =
  'FETCH_DJUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_SUCCESS'
export const FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_ERROR =
  'FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_ERROR'
export const UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_REQUEST =
  'UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_REQUEST'
export const UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_SUCCESS =
  'UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_SUCCESS'

// Feature Check
export const SAVE_FEATURE_CHECK_REQUEST = 'SAVE_FEATURE_CHECK_REQUEST'
export const SAVE_FEATURE_CHECK_ERROR = 'SAVE_FEATURE_CHECK_ERROR'
export const SAVE_FEATURE_CHECK_SUCCESS = 'SAVE_FEATURE_CHECK_SUCCESS'

// Adjustment Values
export const FETCH_ADJUSTMENT_VALUES_REQUEST = 'FETCH_ADJUSTMENT_VALUES_REQUEST'
export const FETCH_ADJUSTMENT_VALUES_SUCCESS = 'FETCH_ADJUSTMENT_VALUES_SUCCESS'
export const FETCH_ADJUSTMENT_VALUES_ERROR = 'FETCH_ADJUSTMENT_VALUES_ERROR'

// Adjustment Done
export const FETCH_ADJUSTMENT_DONE_REQUEST = 'FETCH_ADJUSTMENT_DONE_REQUEST'
export const FETCH_ADJUSTMENT_DONE_SUCCESS = 'FETCH_ADJUSTMENT_DONE_SUCCESS'
export const FETCH_ADJUSTMENT_DONE_ERROR = 'FETCH_ADJUSTMENT_DONE_ERROR'

// Linear Conference
export const FETCH_LINEAR_CONFERENCE_REQUEST = 'FETCH_LINEAR_CONFERENCE_REQUEST'
export const FETCH_LINEAR_CONFERENCE_SUCCESS = 'FETCH_LINEAR_CONFERENCE_SUCCESS'
export const FETCH_LINEAR_CONFERENCE_ERROR = 'FETCH_LINEAR_CONFERENCE_ERROR'

export const FETCH_LINEAR_CONFERENCE_FLUX_REQUEST = 'FETCH_LINEAR_CONFERENCE_REQUEST'
export const FETCH_LINEAR_CONFERENCE_FLUX_SUCCESS = 'FETCH_LINEAR_CONFERENCE_SUCCESS'
export const FETCH_LINEAR_CONFERENCE_FLUX_ERROR = 'FETCH_LINEAR_CONFERENCE_ERROR'

// Manager Branch Mission
export const FETCH_MANAGER_BRANCH_MISSION_REQUEST =
  'FETCH_MANAGER_BRANCH_MISSION_REQUEST'
export const FETCH_MANAGER_BRANCH_MISSION_SUCCESS =
  'FETCH_MANAGER_BRANCH_MISSION_SUCCESS'
export const FETCH_MANAGER_BRANCH_MISSION_ERROR =
  'FETCH_MANAGER_BRANCH_MISSION_ERROR'
export const UPDATE_MANAGER_BRANCH_MISSION_REQUEST =
  'UPDATE_MANAGER_BRANCH_MISSION_REQUEST'
export const UPDATE_MANAGER_BRANCH_MISSION_SUCCESS =
  'UPDATE_MANAGER_BRANCH_MISSION_SUCCESS'
export const UPDATE_MANAGER_BRANCH_MISSION_ERROR =
  'UPDATE_MANAGER_BRANCH_MISSION_ERROR'

export const FETCH_MISSIONS_OPTIONS_REQUEST = 'FETCH_MISSIONS_OPTIONS_REQUEST'
export const FETCH_MISSIONS_OPTIONS_SUCCESS = 'FETCH_MISSIONS_OPTIONS_SUCCESS'
export const FETCH_MISSIONS_OPTIONS_ERROR = 'FETCH_MISSIONS_OPTIONS_ERROR'

// Local users
export const FETCH_LOCAL_USERS_REQUEST = 'FETCH_LOCAL_USERS_REQUEST'
export const FETCH_LOCAL_USERS_SUCCESS = 'FETCH_LOCAL_USERS_SUCCESS'
export const FETCH_LOCAL_USERS_ERROR = 'FETCH_LOCAL_USERS_ERROR'
export const EDIT_LOCAL_USERS_REQUEST = 'EDIT_LOCAL_USERS_REQUEST'
export const EDIT_LOCAL_USERS_SUCCESS = 'EDIT_LOCAL_USERS_SUCCESS'
export const EDIT_LOCAL_USERS_ERROR = 'EDIT_LOCAL_USERS_ERROR'
export const DELETE_LOCAL_USERS_REQUEST = 'DELETE_LOCAL_USERS_REQUEST'
export const DELETE_LOCAL_USERS_SUCCESS = 'DELETE_LOCAL_USERS_SUCCESS'
export const DELETE_LOCAL_USERS_ERROR = 'DELETE_LOCAL_USERS_ERROR'

// Tracking monitor
export const FETCH_SALES_ORDER_LIST_REQUEST = 'FETCH_SALES_ORDER_LIST_REQUEST'
export const FETCH_SALES_ORDER_LIST_SUCCESS = 'FETCH_SALES_ORDER_LIST_SUCCESS'
export const FETCH_SALES_ORDER_LIST_ERROR = 'FETCH_SALES_ORDER_LIST_ERROR'
export const FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_REQUEST =
  'FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_REQUEST'
export const FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_SUCCESS =
  'FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_SUCCESS'
export const FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_ERROR =
  'FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_ERROR'
export const SAVE_TRACKING_MONITOR_REMOVAL_REQUEST =
  'SAVE_TRACKING_MONITOR_REMOVAL_REQUEST'
export const SAVE_TRACKING_MONITOR_REMOVAL_SUCCESS =
  'SAVE_TRACKING_MONITOR_REMOVAL_SUCCESS'
export const SAVE_TRACKING_MONITOR_REMOVAL_ERROR =
  'SAVE_TRACKING_MONITOR_REMOVAL_ERROR'

export const FETCH_QUERY_LOG_REQUEST = 'FETCH_QUERY_LOG_REQUEST'
export const FETCH_QUERY_LOG_SUCCESS = 'FETCH_QUERY_LOG_SUCCESS'
export const FETCH_QUERY_LOG_ERROR = 'FETCH_QUERY_LOG_ERROR'
export const CLEAR_QUERY_LOG = 'CLEAR_QUERY_LOG'

export const FETCH_QUERY_LOG_FILTER = 'FETCH_QUERY_LOG_FILTER'

// Justifications Punctual Adjust
export const FETCH_JUSTIFICATIONS_PA_LIST_REQUEST =
  'FETCH_JUSTIFICATIONS_LIST_REQUEST'
export const FETCH_JUSTIFICATIONS_PA_LIST_SUCCESS =
  'FETCH_JUSTIFICATIONS_LIST_SUCCESS'
export const FETCH_JUSTIFICATIONS_PA_LIST_ERROR =
  'FETCH_JUSTIFICATIONS_LIST_ERROR'
export const UPDATE_JUSTIFICATION_PA_REQUEST = 'UPDATE_JUSTIFICATION_REQUEST'
export const UPDATE_JUSTIFICATION_PA_SUCCESS = 'UPDATE_JUSTIFICATION_SUCCESS'
export const UPDATE_JUSTIFICATION_PA_ERROR = 'UPDATE_JUSTIFICATION_ERROR'

// Demarcate Justification
export const FETCH_JUSTIFICATION_DEMARCATE_LIST_REQUEST =
  'FETCH_JUSTIFICATION_DEMARCATE_LIST_REQUEST'
export const FETCH_JUSTIFICATION_DEMARCATE_LIST_SUCCESS =
  'FETCH_JUSTIFICATION_DEMARCATE_LIST_SUCCESS'
export const FETCH_JUSTIFICATION_DEMARCATE_LIST_ERROR =
  'FETCH_JUSTIFICATION_DEMARCATE_LIST_ERROR'
export const UPDATE_JUSTIFICATION_DEMARCATE_REQUEST =
  'UPDATE_JUSTIFICATION_DEMARCATE_REQUEST'
export const UPDATE_JUSTIFICATION_DEMARCATE_SUCCESS =
  'UPDATE_JUSTIFICATION_DEMARCATE_SUCCESS'
export const UPDATE_JUSTIFICATION_DEMARCATE_ERROR =
  'UPDATE_JUSTIFICATION_DEMARCATE_ERROR'

// Demarcate Disapproval Justification
export const FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_REQUEST =
  'FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_REQUEST'
export const FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_SUCCESS =
  'FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_SUCCESS'
export const FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_ERROR =
  'FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_ERROR'
export const UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_REQUEST =
  'UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_REQUEST'
export const UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_SUCCESS =
  'UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_SUCCESS'
export const UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_ERROR =
  'UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_ERROR'

// Justifications Linear Conference
export const FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_REQUEST =
  'FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_REQUEST'
export const FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_SUCCESS =
  'FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_SUCCESS'
export const FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_ERROR =
  'FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_ERROR'
export const UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_REQUEST =
  'UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_REQUEST'
export const UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_SUCCESS =
  'UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_SUCCESS'
export const UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_ERROR =
  'UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_ERROR'

// Stock transfer report
export const FETCH_STOCK_TRANSFER_REPORT_REQUEST =
  'FETCH_STOCK_TRANSFER_REPORT_REQUEST'
export const FETCH_STOCK_TRANSFER_REPORT_SUCCESS =
  'FETCH_STOCK_TRANSFER_REPORT_SUCCESS'
export const FETCH_STOCK_TRANSFER_REPORT_ERROR =
  'FETCH_STOCK_TRANSFER_REPORT_ERROR'

// Stock transfer mission block
export const FETCH_STOCK_TRANSFER_MISSION_BLOCK_REQUEST =
  'FETCH_STOCK_TRANSFER_MISSION_BLOCK_REQUEST'
export const FETCH_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS =
  'FETCH_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS'
export const FETCH_STOCK_TRANSFER_MISSION_BLOCK_ERROR =
  'FETCH_STOCK_TRANSFER_MISSION_BLOCK_ERROR'
export const SAVE_STOCK_TRANSFER_MISSION_BLOCK_REQUEST =
  'SAVE_STOCK_TRANSFER_MISSION_BLOCK_REQUEST'
export const SAVE_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS =
  'SAVE_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS'
export const SAVE_STOCK_TRANSFER_MISSION_BLOCK_ERROR =
  'SAVE_STOCK_TRANSFER_MISSION_BLOCK_ERROR'

export const UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_REQUEST =
  'UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_REQUEST'
export const UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS =
  'UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS'
export const UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_ERROR =
  'UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_ERROR'

// Stock Transfer Approvers
export const FETCH_STOCK_TRANSFER_APPROVERS_REQUEST = 'FETCH_STOCK_TRANSFER_APPROVERS_REQUEST'
export const FETCH_STOCK_TRANSFER_APPROVERS_SUCCESS = 'FETCH_STOCK_TRANSFER_APPROVERS_SUCCESS'
export const FETCH_STOCK_TRANSFER_APPROVERS_ERROR = 'FETCH_STOCK_TRANSFER_APPROVERS_ERROR'

export const SAVE_STOCK_TRANSFER_APPROVERS_REQUEST = 'SAVE_STOCK_TRANSFER_APPROVERS_REQUEST';
export const SAVE_STOCK_TRANSFER_APPROVERS_SUCCESS = 'SAVE_STOCK_TRANSFER_APPROVERS_SUCCESS';
export const SAVE_STOCK_TRANSFER_APPROVERS_ERROR = 'SAVE_STOCK_TRANSFER_APPROVERS_ERROR';

export const DELETE_STOCK_TRANSFER_APPROVERS_REQUEST = 'DELETE_STOCK_TRANSFER_APPROVERS_REQUEST';
export const DELETE_STOCK_TRANSFER_APPROVERS_SUCCESS = 'DELETE_STOCK_TRANSFER_APPROVERS_SUCCESS';
export const DELETE_STOCK_TRANSFER_APPROVERS_ERROR = 'DELETE_STOCK_TRANSFER_APPROVERS_ERROR';

export const FETCH_STOCK_TRANSFER_APPROVERS_MISSION_REQUEST = 'FETCH_STOCK_TRANSFER_APPROVERS_MISSION_REQUEST';
export const FETCH_STOCK_TRANSFER_APPROVERS_MISSION_SUCCESS = 'FETCH_STOCK_TRANSFER_APPROVERS_MISSION_SUCCESS';
export const FETCH_STOCK_TRANSFER_APPROVERS_MISSION_ERROR = 'FETCH_STOCK_TRANSFER_APPROVERS_MISSION_ERROR';

// Deposit
export const FETCH_DEPOSIT_REQUEST = 'FETCH_DEPOSIT_REQUEST'
export const FETCH_DEPOSIT_SUCCESS = 'FETCH_DEPOSIT_SUCCESS'
export const FETCH_DEPOSIT_ERROR = 'FETCH_DEPOSIT_ERROR'

// Deposit Approval
export const FETCH_DEPOSIT_APPROVAL_REQUEST = 'FETCH_DEPOSIT_APPROVAL_REQUEST'
export const FETCH_DEPOSIT_APPROVAL_SUCCESS = 'FETCH_DEPOSIT_APPROVAL_SUCCESS'
export const FETCH_DEPOSIT_APPROVAL_ERROR = 'FETCH_DEPOSIT_APPROVAL_ERROR'
export const UPDATE_DEPOSIT_APPROVAL_REQUEST = 'UPDATE_DEPOSIT_APPROVAL_REQUEST'
export const UPDATE_DEPOSIT_APPROVAL_SUCCESS = 'UPDATE_DEPOSIT_APPROVAL_SUCCESS'
export const UPDATE_DEPOSIT_APPROVAL_ERROR = 'UPDATE_DEPOSIT_APPROVAL_ERROR'

// Help Configuration
export const FETCH_HELP_CONFIGURATION_REQUEST =
  'FETCH_HELP_CONFIGURATION_REQUEST'
export const FETCH_HELP_CONFIGURATION_SUCCESS =
  'FETCH_HELP_CONFIGURATION_SUCCESS'
export const FETCH_HELP_CONFIGURATION_ERROR = 'FETCH_HELP_CONFIGURATION_ERROR'

export const REMOVE_HELP_CONFIGURATION_REQUEST =
  'REMOVE_HELP_CONFIGURATION_REQUEST'
export const REMOVE_HELP_CONFIGURATION_SUCCESS =
  'REMOVE_HELP_CONFIGURATION_SUCCESS'
export const REMOVE_HELP_CONFIGURATION_ERROR = 'REMOVE_HELP_CONFIGURATION_ERROR'

export const UPDATE_HELP_CONFIGURATION_REQUEST =
  'UPDATE_HELP_CONFIGURATION_REQUEST'
export const UPDATE_HELP_CONFIGURATION_SUCCESS =
  'UPDATE_HELP_CONFIGURATION_SUCCESS'
export const UPDATE_HELP_CONFIGURATION_ERROR = 'UPDATE_HELP_CONFIGURATION_ERROR'

export const FETCH_PRICEBANNER_CONFIG_SUCCESS =
  'FETCH_PRICEBANNER_CONFIG_SUCCESS'
export const FETCH_PRICEBANNER_CONFIG_ERROR = 'FETCH_PRICEBANNER_CONFIG_ERROR'
export const SAVE_PRICEBANNER_CONFIG_SUCCESS = 'SAVE_PRICEBANNER_CONFIG_SUCCESS'
export const SAVE_PRICEBANNER_CONFIG_ERROR = 'SAVE_PRICEBANNER_CONFIG_ERROR'
export const DELETE_PRICEBANNER_CONFIG_SUCCESS =
  'DELETE_PRICEBANNER_CONFIG_SUCCESS'
export const DELETE_PRICEBANNER_CONFIG_ERROR = 'DELETE_PRICEBANNER_CONFIG_ERROR'

export const FETCH_PRICEBANNER_PARAMS_SUCCESS = 'FETCH_PRICEBANNER_PARAMS_SUCCESS'
export const FETCH_PRICEBANNER_PARAMS_ERROR = 'FETCH_PRICEBANNER_PARAMS_ERROR'
export const SAVE_PRICEBANNER_PARAMS_SUCCESS = 'SAVE_PRICEBANNER_PARAMS_SUCCESS'
export const SAVE_PRICEBANNER_PARAMS_ERROR = 'SAVE_PRICEBANNER_PARAMS_ERROR'
export const UPDATE_PRICEBANNER_PARAMS_SUCCESS = 'UPDATE_PRICEBANNER_PARAMS_SUCCESS'
export const UPDATE_PRICEBANNER_PARAMS_ERROR = 'UPDATE_PRICEBANNER_PARAMS_ERROR'
export const DELETE_PRICEBANNER_PARAMS_SUCCESS = 'DELETE_PRICEBANNER_PARAMS_SUCCESS'
export const DELETE_PRICEBANNER_PARAMS_ERROR = 'DELETE_PRICEBANNER_PARAMS_ERROR'

export const FETCH_PRICEBANNER_LIST_SUCCESS = 'FETCH_PRICEBANNER_LIST_SUCCESS'
export const FETCH_PRICEBANNER_LIST_ERROR = 'FETCH_PRICEBANNER_LIST_ERROR'
export const UPDATE_PRICEBANNER_LIST_SUCCESS = 'UPDATE_PRICEBANNER_LIST_SUCCESS'
export const UPDATE_PRICEBANNER_LIST_ERROR = 'UPDATE_PRICEBANNER_LIST_ERROR'
export const DELETE_PRICEBANNER_LIST_SUCCESS = 'DELETE_PRICEBANNER_LIST_SUCCESS'
export const DELETE_PRICEBANNER_LIST_ERROR = 'DELETE_PRICEBANNER_LIST_ERROR'
export const UPLOAD_PRICEBANNER_LIST_SUCCESS = 'UPLOAD_PRICEBANNER_LIST_SUCCESS'
export const UPLOAD_PRICEBANNER_LIST_ERROR = 'UPLOAD_PRICEBANNER_LIST_ERROR'
export const CLEAR_PRICEBANNER_LIST = 'CLEAR_PRICEBANNER_LIST'

export const VALIDATE_PRICEBANNER_PRODUCTS_SUCCESS = 'VALIDATE_PRICEBANNER_PRODUCTS_SUCCESS'
export const VALIDATE_PRICEBANNER_PRODUCTS_ERROR = 'VALIDATE_PRICEBANNER_PRODUCTS_ERROR'
export const ADD_PRODUCTS_TO_LIST_SUCCESS = 'ADD_PRODUCTS_TO_LIST_SUCCESS'
export const ADD_PRODUCTS_TO_LIST_ERROR = 'ADD_PRODUCTS_TO_LIST_ERROR'
export const DELETE_PRICEBANNER_PRODUCT_SUCCESS = 'DELETE_PRICEBANNER_PRODUCT_SUCCESS'
export const DELETE_PRICEBANNER_PRODUCT_ERROR = 'DELETE_PRICEBANNER_PRODUCT_ERROR'

export const FETCH_PRICEFY_CONFIG_SUCCESS = 'FETCH_PRICEFY_CONFIG_SUCCESS'
export const FETCH_PRICEFY_CONFIG_ERROR = 'FETCH_PRICEFY_CONFIG_ERROR'

export const FETCH_PARCEL_SUCCESS = 'FETCH_PARCEL_SUCCESS'
export const FETCH_PARCEL_ERROR = 'FETCH_PARCEL_ERROR'

// Delimit report
export const FETCH_DELIMIT_REPORT_REQUEST = 'FETCH_DELIMIT_REPORT_REQUEST'
export const FETCH_DELIMIT_REPORT_SUCCESS = 'FETCH_DELIMIT_REPORT_SUCCESS'
export const FETCH_DELIMIT_REPORT_ERROR = 'FETCH_DELIMIT_REPORT_ERROR'

export const FETCH_PRICE_AUDIT_REPORT_REQUEST = 'FETCH_PRICE_AUDIT_REPORT_REQUEST'
export const FETCH_PRICE_AUDIT_REPORT_SUCCESS = 'FETCH_PRICE_AUDIT_REPORT_SUCCESS'
export const FETCH_PRICE_AUDIT_REPORT_ERROR = 'FETCH_PRICE_AUDIT_REPORT_ERROR'


export const USE_CONSUME_REQUEST = "USE_CONSUME_REQUEST"
export const USE_CONSUME_SUCCESS = "USE_CONSUME_SUCCESS"
export const USE_CONSUME_ERROR = "USE_CONSUME_ERROR"

export const FETCH_USE_CONSUME_APPROVERS_REQUEST =
  'FETCH_USE_CONSUME_APPROVERS_REQUEST'

export const FETCH_USE_CONSUME_APPROVERS_ERROR =
  'FETCH_USE_CONSUME_APPROVERS_ERROR'

export const FETCH_USE_CONSUME_APPROVERS_SUCCESS =
  'FETCH_USE_CONSUME_APPROVERS_SUCCESS'
// Approving Missions
export const FETCH_USAGE_CONSUMPTION_APPROVERS_REQUEST =
  'FETCH_USAGE_CONSUMPTION_APPROVERS_REQUEST'
export const FETCH_USAGE_CONSUMPTION_APPROVERS_SUCCESS =
  'FETCH_USAGE_CONSUMPTION_APPROVERS_SUCCESS'
export const FETCH_USAGE_CONSUMPTION_APPROVERS_ERROR =
  'FETCH_USAGE_CONSUMPTION_APPROVERS_ERROR'
export const UPDATE_USAGE_CONSUMPTION_APPROVERS_REQUEST =
  'UPDATE_USAGE_CONSUMPTION_APPROVERS_REQUEST'
export const UPDATE_USAGE_CONSUMPTION_APPROVERS_SUCCESS =
  'UPDATE_USAGE_CONSUMPTION_APPROVERS_SUCCESS'
export const UPDATE_USAGE_CONSUMPTION_APPROVERS_ERROR =
  'UPDATE_USAGE_CONSUMPTION_APPROVERS_ERROR'

export const CHANGE_USAGE_CONSUMPTION_APPROVERS_REQUEST =
  'CHANGE_USAGE_CONSUMPTION_APPROVERS_REQUEST'
export const CHANGE_USAGE_CONSUMPTION_APPROVERS_SUCCESS =
  'CHANGE_USAGE_CONSUMPTION_APPROVERS_SUCCESS'
export const CHANGE_USAGE_CONSUMPTION_APPROVERS_ERROR =
  'CHANGE_USAGE_CONSUMPTION_APPROVERS_ERROR'

export const USAGE_CONSUMPTION_RESET =
  'USAGE_CONSUMPTION_APPROVERS_RESET'

export const DELETE_USAGE_CONSUMPTION_APPROVERS_REQUEST =
  'DELETE_USAGE_CONSUMPTION_APPROVERS_REQUEST'
export const DELETE_USAGE_CONSUMPTION_APPROVERS_SUCCESS =
  'DELETE_USAGE_CONSUMPTION_APPROVERS_SUCCESS'
export const DELETE_USAGE_CONSUMPTION_APPROVERS_ERROR =
  'DELETE_USAGE_CONSUMPTION_APPROVERS_ERROR'

// Use and Consume Justification
export const FETCH_USE_CONSUME_JUSTIFICATION_LIST_REQUEST =
  'FETCH_USE_CONSUME_JUSTIFICATION_LIST_REQUEST'
export const FETCH_USE_CONSUME_JUSTIFICATION_LIST_SUCCESS =
  'FETCH_USE_CONSUME_JUSTIFICATION_LIST_SUCCESS'
export const FETCH_USE_CONSUME_JUSTIFICATION_LIST_ERROR =
  'FETCH_USE_CONSUME_JUSTIFICATION_LIST_ERROR'
export const UPDATE_USE_CONSUME_JUSTIFICATION_REQUEST =
  'UPDATE_USE_CONSUME_JUSTIFICATION_REQUEST'
export const UPDATE_USE_CONSUME_JUSTIFICATION_SUCCESS =
  'UPDATE_USE_CONSUME_JUSTIFICATION_SUCCESS'
export const UPDATE_USE_CONSUME_JUSTIFICATION_ERROR =
  'UPDATE_USE_CONSUME_JUSTIFICATION_ERROR'

// Usage and consumption report
export const FETCH_USAGE_CONSUMPTION_REPORT_REQUEST =
  'FETCH_USAGE_CONSUMPTION_REPORT_REQUEST'
export const FETCH_USAGE_CONSUMPTION_REPORT_SUCCESS =
  'FETCH_USAGE_CONSUMPTION_REPORT_SUCCESS'
export const FETCH_USAGE_CONSUMPTION_REPORT_ERROR =
  'FETCH_USAGE_CONSUMPTION_REPORT_ERROR'
export const FETCH_USAGE_CONSUMPTION_STATUS_REQUEST =
  'FETCH_USAGE_CONSUMPTION_STATUS_REQUEST'
export const FETCH_USAGE_CONSUMPTION_STATUS_SUCCESS =
  'FETCH_USAGE_CONSUMPTION_STATUS_SUCCESS'
export const FETCH_USAGE_CONSUMPTION_STATUS_ERROR =
  'FETCH_USAGE_CONSUMPTION_STATUS_ERROR'

// Exclusion sub type
export const FETCH_EXCLUSION_SUBTYPE_REQUEST = 'FETCH_EXCLUSION_SUBTYPE_REQUEST'
export const FETCH_EXCLUSION_SUBTYPE_SUCCESS = 'FETCH_EXCLUSION_SUBTYPE_SUCCESS'
export const FETCH_EXCLUSION_SUBTYPE_ERROR = 'FETCH_EXCLUSION_SUBTYPE_ERROR'
export const SAVE_EXCLUSION_SUBTYPE_REQUEST = 'SAVE_EXCLUSION_SUBTYPE_REQUEST'
export const SAVE_EXCLUSION_SUBTYPE_SUCCESS = 'SAVE_EXCLUSION_SUBTYPE_SUCCESS'
export const SAVE_EXCLUSION_SUBTYPE_ERROR = 'SAVE_EXCLUSION_SUBTYPE_ERROR'
export const REMOVE_EXCLUSION_SUBTYPE_REQUEST =
  'REMOVE_EXCLUSION_SUBTYPE_REQUEST'
export const REMOVE_EXCLUSION_SUBTYPE_SUCCESS =
  'REMOVE_EXCLUSION_SUBTYPE_SUCCESS'
export const REMOVE_EXCLUSION_SUBTYPE_ERROR = 'REMOVE_EXCLUSION_SUBTYPE_ERROR'

export const CHANGE_MENU_ITEM_SELECTION = 'CHANGE_MENU_ITEM_SELECTION'
export const FETCH_NEW_HOME_MENUS_FILTER_REQUEST =
  'FETCH_NEW_HOME_MENUS_REQUEST'
export const FETCH_NEW_HOME_MENUS_FILTER_FAILURE =
  'FETCH_NEW_HOME_MENUS_FAILURE'
export const FETCH_NEW_HOME_MENUS_FILTER_SUCCESS =
  'FETCH_NEW_HOME_MENUS_SUCCESS'

export const FETCH_CURRENT_BASE_ERROR = 'FETCH_CURRENT_BASE_ERROR'
export const FETCH_CURRENT_BASE_SUCCESS = 'FETCH_CURRENT_BASE_SUCCESS'
export const SET_MENU_MISSIONS_TABLE_SORTING = 'SET_MENU_MISSIONS_TABLE_SORTING'

export const FETCH_BEEPING_REPORT_SUCCESS = 'FETCH_BEEPING_REPORT_SUCCESS'
export const FETCH_BEEPING_REPORT_ERROR = 'FETCH_BEEPING_REPORT_ERROR'

// DemarcateJustifies
export const FETCH_DEMARCATE_JUSTIFY_FILTER_REQUEST =
  'FETCH_DEMARCATE_JUSTIFY_FILTER_REQUEST'
export const FETCH_DEMARCATE_JUSTIFY_FILTER_SUCCESS =
  'FETCH_DEMARCATE_JUSTIFY_FILTER_SUCCESS'
export const FETCH_DEMARCATE_JUSTIFY_FILTER_ERROR =
  'FETCH_DEMARCATE_JUSTIFY_FILTER_ERROR'
export const FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_REQUEST =
  'FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_REQUEST'
export const FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_SUCCESS =
  'FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_REQUEST'
export const FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_ERROR =
  'FETCH_DEMARCATE_JUSTIFY_SAVE_UPDATE_REQUEST'
export const FETCH_DEMARCATE_JUSTIFY_DELETE_REQUEST =
  'FETCH_DEMARCATE_JUSTIFY_DELETE_REQUEST'
export const FETCH_DEMARCATE_JUSTIFY_DELETE_SUCCESS =
  'FETCH_DEMARCATE_JUSTIFY_DELETE_SUCCESS'
export const FETCH_DEMARCATE_JUSTIFY_DELETE_ERROR =
  'FETCH_DEMARCATE_JUSTIFY_DELETE_ERROR'

// NEXP
export const SAVE_PARAMS_NEXP_REQUEST = "SAVE_PARAMS_NEXP_REQUEST"
export const SAVE_PARAMS_NEXP_REQUEST_SUCCESS = "SAVE_PARAMS_NEXP_REQUEST_SUCCESS"
export const SAVE_PARAMS_NEXP_REQUEST_ERROR = "SAVE_PARAMS_NEXP_REQUEST_ERROR"
export const FETCH_PARAMS_NEXP_REQUEST = "FETCH_PARAMS_NEXP_REQUEST"
export const FETCH_PARAMS_NEXP_REQUEST_SUCCESS = "FETCH_PARAMS_NEXP_REQUEST_SUCCESS"
export const FETCH_PARAMS_NEXP_REQUEST_ERROR = "FETCH_PARAMS_NEXP_REQUEST_ERROR"
export const FETCH_SECTIONS_DEFAULT = "FETCH_SECTIONS_DEFAULT"

// SUPPLY
export const SAVE_PARAMS_SUPPLY_REQUEST = "SAVE_PARAMS_SUPPLY_REQUEST"
export const SAVE_PARAMS_SUPPLY_REQUEST_SUCCESS = "SAVE_PARAMS_SUPPLY_REQUEST_SUCCESS"
export const SAVE_PARAMS_SUPPLY_REQUEST_ERROR = "SAVE_PARAMS_SUPPLY_REQUEST_ERROR"
export const FETCH_PARAMS_SUPPLY_REQUEST = "FETCH_PARAMS_SUPPLY_REQUEST"
export const FETCH_PARAMS_SUPPLY_REQUEST_SUCCESS = "FETCH_PARAMS_SUPPLY_REQUEST_SUCCESS"
export const FETCH_PARAMS_SUPPLY_REQUEST_ERROR = "FETCH_PARAMS_SUPPLY_REQUEST_ERROR"
// ATTRIBUTE

export const SAVE_ATTRIBUTE_FORM_REQUEST = 'SAVE_ATTRIBUTE_FORM_REQUEST'
export const SAVE_ATTRIBUTE_FORM_SUCCESS = 'SAVE_ATTRIBUTE_FORM_SUCCESS'
export const SAVE_ATTRIBUTE_FORM_ERROR = 'SAVE_ATTRIBUTE_FORM_ERROR'


export const UPDATE_ATTRIBUTE_FORM_REQUEST = 'UPDATE_ATTRIBUTE_FORM_REQUEST'
export const UPDATE_ATTRIBUTE_FORM_SUCCESS = 'UPDATE_ATTRIBUTE_FORM_SUCCESS'
export const UPDATE_ATTRIBUTE_FORM_ERROR = 'UPDATE_ATTRIBUTE_FORM_ERROR'


export const FETCH_ATTRIBUTE_FORM_REQUEST = 'FETCH_ATTRIBUTE_FORM_REQUEST'
export const FETCH_ATTRIBUTE_FORM_SUCCESS = 'FETCH_ATTRIBUTE_FORM_SUCCESS'
export const FETCH_ATTRIBUTE_FORM_ERROR = 'FETCH_ATTRIBUTE_FORM_ERROR'

export const RESET_STATE_ATTRIBUTE = "RESET_STATE_ATTRIBUTE"

export const FETCH_EXTERNAL_APIS_REQUEST = 'FETCH_EXTERNAL_APIS_REQUEST'
export const FETCH_EXTERNAL_APIS_SUCCESS = 'FETCH_EXTERNAL_APIS_SUCCESS'
export const FETCH_EXTERNAL_APIS_ERROR = 'FETCH_EXTERNAL_APIS_ERROR'
export const UPDATE_EXTERNAL_API_REQUEST = 'UPDATE_EXTERNAL_API_REQUEST'
export const UPDATE_EXTERNAL_API_SUCCESS = 'UPDATE_EXTERNAL_API_SUCCESS'
export const UPDATE_EXTERNAL_API_ERROR = 'UPDATE_EXTERNAL_API_ERROR'
export const TOGGLE_EXTERNAL_API_TARGET_REQUEST = 'TOGGLE_EXTERNAL_API_TARGET_REQUEST'
export const TOGGLE_EXTERNAL_API_TARGET_SUCCESS = 'TOGGLE_EXTERNAL_API_TARGET_SUCCESS'
export const TOGGLE_EXTERNAL_API_TARGET_ERROR = 'TOGGLE_EXTERNAL_API_TARGET_ERROR'
export const RESET_EXTERNAL_APIS = 'RESET_EXTERNAL_APIS'
